<div *ngIf="!params.data.IsActive" class="inactiveColor">
    <svg class="icon-16">
        <use href="../App_Themes/CXone/icons/user-inactive.svg#user-inactive"></use>
    </svg>
    <span [ngbPopover]="inactiveMessage" triggers="mouseenter:mouseleave" container="body" class="text-truncate groupName" containerClass="cx-one-ui"> 
        {{params.data.Group.groupName}}
    </span>
</div>
<div *ngIf="params.data.IsActive" class="text">
    <span [ngbPopover]="params.data.Group.groupName" triggers="mouseenter:mouseleave" container="body" class="text-truncate groupName" containerClass="cx-one-ui"> 
        {{params.data.Group.groupName}}
    </span>
</div>